import { render, staticRenderFns } from "./ToDose.vue?vue&type=template&id=11af2528&"
import script from "./ToDose.vue?vue&type=script&lang=ts&"
export * from "./ToDose.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports